<template>
  <div class="visa-card mt-5" @click="routeClick('Wallet')" style="cursor: pointer">
    <div class="logoContainer">
      <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="23"
          height="23"
          viewBox="0 0 48 48"
          class="svgLogo"
      >
        <path
            fill="#c9184a"
            d="M32 10A14 14 0 1 0 32 38A14 14 0 1 0 32 10Z"
        ></path>
        <path
            fill="#800f2f"
            d="M16 10A14 14 0 1 0 16 38A14 14 0 1 0 16 10Z"
        ></path>
        <path
            fill="#590d22"
            d="M18,24c0,4.755,2.376,8.95,6,11.48c3.624-2.53,6-6.725,6-11.48s-2.376-8.95-6-11.48 C20.376,15.05,18,19.245,18,24z"
        ></path>
      </svg>
    </div>
    <div class="number-container">
      <label class="input-label" style="text-align: left;" for="cardNumber">EXUNI BALANCE</label>
      <strong
          class="white--text inputstyle mt-2"
          id="cardNumber"
      >
        {{user.wallet.balance | toMoney}}

      </strong>
    </div>

    <div class="name-date-cvv-container">
      <div class="name-wrapper">
        <label class="input-label" for="holderName">CARD HOLDER</label>
        <strong
            class="card-name"
            id="holderName"
        >{{user.name}}</strong>
      </div>

      <div class="expiry-wrapper">
        <label class="input-label" for="expiry">VALID THRU</label>
        <strong
            class="card-name"
            id="expiry"
        >{{serverNow.format("jYYYY/jMM/jDD")}}</strong>
      </div>
      <div class="cvv-wrapper">
        <label class="input-label" for="cvv">CVV</label>
        <strong
            class="white--text"
            id="cvv"
        >***</strong>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: "FinanceCard",
  mixins: [],
  data() {
    return {
    };
  },
  computed: {
    items() {
      return [];
    },
  },
  mounted() {
  },
  methods: {
    routeClick(routeName) {
      this.$router.push({name: routeName})
    },

  },
};
</script>
<style>
.visa-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  width: 90%;
  margin: auto;
  height: 180px;
  background-image: radial-gradient(
      circle 897px at 9% 80.3%,
      #FF5D8F 0%,
      #FADDE1 100.2%
  );
  border-radius: 10px;
  padding: 20px;
  font-family: Arial, Helvetica, sans-serif;
  position: relative;
  gap: 15px;
}
.logoContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: fit-content;
  position: absolute;
  top: 0;
  left: 0;
  padding: 18px;
}
.svgLogo {
  height: 40px;
  width: auto;
}
.inputstyle::placeholder {
  color: #ffffff;
}
.inputstyle {
  text-align: left;
  background-color: transparent;
  border: none;
  outline: none;
  color: white;
  caret-color: #590d22;
  font-size: 13px;
  height: 25px;
  letter-spacing: 1.5px;
}
.number-container {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
}
#cardNumber {
  width: 100%;
  height: 25px;
}
.name-date-cvv-container {
  width: 100%;
  height: 25px;
  display: flex;
  gap: 10px;
}
.name-wrapper {
  width: 60%;
  height: fit-content;
  display: flex;
  flex-direction: column;
}
.expiry-wrapper,
.cvv-wrapper {
  width: 30%;
  height: fit-content;
  display: flex;
  flex-direction: column;
}
.cvv-wrapper {
  width: 10%;
}
#expiry,
#cvv {
  width: 100%;
}
.input-label {
  font-size: 8px;
  letter-spacing: 1.5px;
  color: #e2e2e2;
  width: 100%;
}
.card-name {
  color: white;
  font-family: IRANSans;
}

</style>
